import { Component, OnInit, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, combineLatest } from 'rxjs';
import { InvitationService } from 'src/app/services/invitation.service';
import { UtilsService } from 'src/app/services/utils.service';
import { fromConsultant } from 'src/app/reducers/consultant.reducer';
import { fromSelectedCandidates } from 'src/app/reducers/selected-candidates.reducer';
import { fromJobtypes } from 'src/app/reducers/jobtypes.reducer';
import { fromTestModels } from 'src/app/reducers/test-models.reducer';
import { Candidate } from 'src/app/models/candidate.model';
import { TestModel } from 'src/app/models/test-model.model';
import { Jobtype } from 'src/app/models/jobtype.model';
import { finalize, take } from 'rxjs/operators';
import { Pagination } from 'src/app/models/pagination.model';
import { Process } from 'src/app/models/process.model';
import { ProcessService } from 'src/app/services/process.service';
import { setProcesses } from 'src/app/actions/processes.actions';
import { fromProcesses } from 'src/app/reducers/processes.reducer';
import * as helpers from '../../../helpers/helpers';
import { Consultant } from 'src/app/models/consultant.model';
import { Router } from '@angular/router';
import { Children, Contacts, Project } from 'src/app/models/project';
import { AppConfig } from 'src/app/helpers/app.config';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ct-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss']
})
export class InviteComponent implements OnInit, OnDestroy {

  @ViewChild('content') content;
  @ViewChild('contactContent') contactContent;

  @Output() inviteSent = new EventEmitter();

  modalRef: NgbModalRef;
  closeResult: string;
  selectedCandidates$: Observable<Candidate[]>;
  jobtypes$: Observable<Jobtype[]>;
  testModels$: Observable<TestModel[]>;
  processes$: Observable<Pagination<Process>>;
  consultant$: Observable<Consultant>;

  showAsModal = true;
  step: 'tests' | 'skill' | 'knowledge' | 'testsUploadProgress' | 'testsUploadResume' = 'tests';
  process: Process = null;
  jobtype: Jobtype = null;
  jobtypeSelected: Jobtype;
  language: number = null;
  skillTests: string[] = [];
  knowledgeTests: TestModel[] = [];
  autonotifyCtReports: TestModel[] = [];
  lastTestsAdded = 0;
  bussinessArea: number[];
  officeId: number = null;
  regionId: number = null;
  HCC: number[];
  notifyAdnReport: boolean;
  notifyMindsetDigitalReport: boolean;
  projects: Project[];
  projectId = null;
  contacts: Contacts[];
  projectSelected: Children;
  checkErrors: boolean;
  urlToken: string;
  isUploadFile: boolean;
  invitationResult: any[];
  languages = {
    1: 'LANGUAGE.SPANISH',
    7: 'LANGUAGE.ENGLISH',
    5: 'LANGUAGE.PORTUGUESE'
  };
  public isCollapsed = true;

  multipleInvitationResult: any[];
  totalCandidates: number;
  responseTimes: number[] = [];
  errorEmails: string[] = [];
  reminderEmails: string[] = [];
  TestFromCtArr = [1, 2, 24, 25, 26];
  evalualiaTest: boolean;
  languageRequired: boolean;
  knowledgeTestLevels = [];

  showTestLevels = false;
  currentConsultant: Consultant;

  constructor(
    private store: Store,
    private modal: NgbModal,
    private invitationService: InvitationService,
    public utilsService: UtilsService,
    private processService: ProcessService,
    private router: Router,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.selectedCandidates$ = this.store.pipe(select(fromSelectedCandidates.selectSelectedCandidatesState));
    this.jobtypes$ = this.store.pipe(select(fromJobtypes.selectBusinessJobtypes));
    this.testModels$ = this.store.pipe(select(fromTestModels.selectTestModelsAlphabetically));
    this.processes$ = this.store.pipe(select(fromProcesses.selectProcessesState));
    this.consultant$ = this.store.pipe(select(fromConsultant.selectConsultantState));
    this.HCC = [];
    this.HCC = AppConfig.settings.OFFICES_WITH_PROJECTS.split(',').map(officeId => Number(officeId));
    this.urlToken = undefined;
    this.isUploadFile = false;
    this.invitationResult = [];
    this.multipleInvitationResult = [];
    this.evalualiaTest = false;
    this.testModels$.subscribe(result =>
      result.forEach(model => model?.levels?.forEach(level => level.optional ? this.knowledgeTestLevels.push({
        description: level.description,
        value: level.id,
        testModelId: model.id,
        checked: true
      }) : null))
    );
    this.consultant$.subscribe(consultant =>
      this.currentConsultant = consultant
    )
  }

  // apertura de la modal de invitación
  open(isFileUpload?: boolean) {
    this.notifyMindsetDigitalReport = false;
    this.notifyAdnReport = true;
    this.urlToken = undefined;
    // Reseteamos los valores de la modal cuando se abre de nuevo
    this.knowledgeTests = [];
    this.autonotifyCtReports = [];
    this.skillTests = [];
    // Por defecto, el español del cliente
    this.language = this.currentConsultant.client.id;
    this.jobtype = null;
    this.evalualiaTest = false;
    this.languageRequired = false;
    this.showTestLevels = false;
    this.projectId = null;


    if (isFileUpload) {
      this.showAsModal = false;
    }

    this.store.pipe(select(fromConsultant.selectConsultantState)).subscribe(consultant => {
      this.bussinessArea = consultant?.office.businessAreaIds;
      this.officeId = consultant?.office.randstadOffice;
      this.regionId = consultant?.office.regionId;
      this.isUploadFile = isFileUpload;
      if (this.HCC.includes(this.officeId)) {
        this.getprojects(consultant);
      }
      // Recuperamos los procesos actualizados de la oficina si venimos de creación de procesos o si es la primera vez que entramos
      // Sino no es necesario actualizar los procesos
      if (localStorage.getItem('inviteInitied') === 'true' || localStorage.getItem('processes') === 'null') {
        this.processService.search({ name: '', clientId: consultant.client.id, officeId: consultant.office.id }, 0).pipe(take(1)).subscribe(processes => {
          this.store.dispatch(setProcesses(processes));
          // Seleccionamos el proceso General por defecto.
          this.processes$.pipe(take(1)).subscribe(processes => {
            this.process = processes.data.find(process => process.id === 1);
          });
        },
          error => this.utilsService.toast('error', 'CannotGetProcesses', true, this.utilsService.getNacsData({ endpoint: 'GET' + AppConfig.settings.API + ' /processes?origin=ct', body: { name: '', clientId: consultant.client.id, officeId: consultant.office.id }, error: { errorType: error.errorType, errorCode: error.errorCode, message: error.message } }))
        );
      } else {
        // Seleccionamos el proceso General por defecto.
        this.processes$.pipe(take(1)).subscribe(processes =>
          this.process = processes.data.find(process => !process.officeId));
      }
    });

    if (!this.modal.hasOpenModals() && !isFileUpload) {
      this.modalRef = this.modal.open(this.content, {
        ariaLabelledBy: 'Invitar-Candidato', size: 'xl', centered: true, backdrop: 'static', keyboard: false
      });
      this.modalRef.result.then((result) => {
        this.closeResult = 'Closed with: ' + result;
      }, (reason) => {
        this.step = 'tests';
        this.closeResult = 'Dismissed ';
      });
    }
    // Marcamos que ya ha acabado la invitación para que al volver a la pantalla de candidatos no lance la modal
    localStorage.setItem('inviteInitied', 'false');
  }

  toogleTest(testModel?: TestModel): boolean {
    // lógica de los test de ADN
    if (this.step === 'skill') {
      if (this.jobtype) {
        this.skillTests.pop();
        this.skillTests.push(this.jobtype.name);
        this.lastTestsAdded++;
        this.checkErrors = false;
      } else {
        this.checkErrors = true;
        return false;
      }
    }
    // lógica para los test de conocimientos
    else if (this.step === 'knowledge' && testModel) {
      // En el cado de que el test no este en el array se añade
      if (!this.knowledgeTests.includes(testModel)) {
        this.knowledgeTests.push(testModel);
        // Volvemos a marcar todos los niveles del test que hemos vuelto a marcar
        this.knowledgeTestLevels.forEach(level => { if (level.testModelId == testModel.id) level.checked = true; });
        // añadida autonotificación por defecto
        this.toggleAutonotifyCtReport(testModel, 'add');
        this.lastTestsAdded++;
        // En el caso de que ya este añadido el test al array se elimina
      } else if (this.knowledgeTests.includes(testModel)) {
        this.knowledgeTests = this.knowledgeTests.filter(t => t.id !== testModel.id);
        // eliminada autonotificación al eliminar el test
        this.toggleAutonotifyCtReport(testModel, 'remove');
        this.lastTestsAdded--;
      }

    }
    return true;
  }

  // gestión de la autonotificación de los resportes de test de ct
  toggleAutonotifyCtReport(testModel: TestModel, action: string) {
    if (testModel.origin === 'ct') {
      if ((action === 'toggle' && !this.autonotifyCtReports.includes(testModel)) || action === 'add') {
        this.autonotifyCtReports.push(testModel);
      } else if (action === 'toggle' && (this.autonotifyCtReports.includes(testModel)) || action === 'remove') {
        this.autonotifyCtReports = this.autonotifyCtReports.filter(t => t.id !== testModel.id);
      }
    }
  }

  // lógica ejecutada tras dejar de añadir tests al array de invitación al cancelar (se eliminan los añadidos) o finalizar.
  stopAdding(action: string) {
    if (action === 'cancel') {
      if (this.step === 'knowledge') {
        // eliminar los ultimos tests que se hayan añadido
        this.knowledgeTests.splice(0 - this.lastTestsAdded, this.lastTestsAdded);
        this.autonotifyCtReports.splice(0 - this.lastTestsAdded, this.lastTestsAdded);
      }
    }
    else if (action === 'finish') {
      this.showLanguageRequired();
      if (this.step === 'skill') {
        if (!this.toogleTest()) {
          return;
        }
      }

      if (this.step === 'knowledge') {
        this.showEvalualiaWarning();
      }
    }
    this.lastTestsAdded = 0;
    this.step = 'tests';
  }

  // obtención del jobtype del proceso para setearlo como predefinido
  setJobtypeFromProcess() {
    if (this.process.jobtypeId) {
      this.jobtypes$.subscribe(jobtypes => {
        this.jobtype = jobtypes.find(jobtype => jobtype.id === this.process.jobtypeId);
      });
      this.skillTests = [];
    } else {
      this.jobtype = null;
    }
  }

  // envío de invitación al candidato
  async invite(assignAndCopy?: boolean) {
    combineLatest([
      this.selectedCandidates$,
      this.consultant$,
    ]).pipe(take(1)).subscribe(([candidates, consultant]) => {

      const propertyCandi = {
        candidateId: candidates.map(candidate => ({ id: candidate.id, randstadCandidate: candidate.randstadCandidate })),
        clientId: consultant.client.id,
        officeId: consultant.office.id,
        jobtypeId: this.skillTests.length ? this.jobtype.id : null,
        languageId: this.language,
        invitationGroupId: this.process.id,
        tests: this.getTests(),
        projectId: (this.projectSelected) ? this.projectSelected.id : null,
        onlyCreate: assignAndCopy
      };
      if (!this.isUploadFile || !this.isUploadFile) {
        this.invitationService.sendV2(propertyCandi).subscribe(invitation => {

          this.modalRef.close('Invitation Sent');
          this.notifyAdnReport = false;
          this.notifyMindsetDigitalReport = false;
          this.inviteSent.emit();

          if (assignAndCopy) {
            // una invitación
            this.utilsService.toast('success', 'INVITESCOPY');
            this.urlToken = this.utilsService.getHomeLink(invitation[0].token);
            if (this.urlToken) {
              this.copyHomeLink(this.urlToken);
            }
          } else {
            this.utilsService.toast('success', 'InviteSent');
          }

        }, error => {
          if (error.message === 'El candidato tiene una prueba pendiente para ese Jobtype.') {
            this.utilsService.toast('warning', 'CandidateHasPendingTest');

          } else if (error.message === 'No se puede invitar a la prueba. Dispone de una prueba sin finalizar.') {
            this.utilsService.toast('warning', 'CandidateHasPendingTestEvalualia');
          } else {
            // Modificada la respuesta de error por problema en producción #ESFBITE-554
            // this.utilsService.toast('error', candidates.length > 1 ? 'CannotSendInviteMassive' : 'CannotSendInvite', true, this.utilsService.getNacsData({endpoint: 'POST' + AppConfig.settings.API + ' /tests?origin=ct', body: propertyCandi, error: {errorType: error.errorType, errorCode: error.errorCode, message: error.message}}));
            if (candidates.length > 1) {
              this.utilsService.toast('error', 'CannotSendInviteMassive');
            } else {
              this.utilsService.toast('error', 'Unexpected');
            }
          }
        }); // suscribe send

      } else {

        // Determinamos las constantes.
        const size = (AppConfig.settings.SIZE_ARRAY_IN_GROUP) ? (AppConfig.settings.SIZE_ARRAY_IN_GROUP * 1) : 3;
        const elements = this.utilsService.arrayInGroups(
          candidates.map(candidate => ({ id: candidate.id, randstadCandidate: candidate.randstadCandidate })), size
        );
        this.totalCandidates = candidates.length;
        this.step = 'testsUploadProgress';
        // Invitamos a modo secuencial, los candidatos seleccionados, en bloques definidos por size.
        this.setInviteAsSequence(elements, consultant.office.id, 0, assignAndCopy, candidates, consultant.client.id);
      }

      this.projectSelected = undefined;
    });

  }

  getTestModelsIds(): number[] {
    const testModelsIds: number[] = [];
    if (this.skillTests.length) {
      const businessIds = helpers.getBusinessIdsFromBussiness(this.jobtype?.businessArea);
      this.consultant$.subscribe(consultant => {
        if (businessIds.includes(2) && consultant.office.businessAreaIds.includes(2)) {
          testModelsIds.push(2);
        } else if (businessIds.includes(1)) {
          testModelsIds.push(1);
        }
      });
    }
    testModelsIds.push(...this.knowledgeTests.map(test => test.id));
    // si no se esta enviando ningun test de adn normativo se cancela la la notifiación automática de Mindset
    if (testModelsIds.includes(1)) {
      this.notifyMindsetDigitalReport = false;
    }
    return testModelsIds;
  }

  getDefault(c1: Process, c2: Process): boolean {
    return c1 ? c1.name.toLowerCase() === 'general' : false;
  }

  createProcess() {
    this.modal.dismissAll();
    // Marcamos que ya esta empezada la invitación para que al volver a la pantalla de candidatos lance la modal
    localStorage.setItem('inviteInitied', 'true');
    this.router.navigate(['consultant/processes/create']);
  }

  getbusinessId() {
    return helpers.getBusinessIdsFromBussiness(this.jobtype?.businessArea);
  }

  getprojects(consultant) {
    this.projectSelected = undefined;
    this.projects = [];
    this.projects = consultant.projects ?? [];
  }

  copyInvitationLink() {
    this.invite(true);
  }

  showModalContact(contactContent) {
    this.modalRef = this.modal.open(this.contactContent, {
      ariaLabelledBy: 'Contacto', centered: true, backdrop: 'static', keyboard: false
    });
  }

  setProject() {
    if (this.projectId && this.projectId !== 'null') {
      this.projectSelected = this.projects.find(
        parentProject => parentProject.id == this.projectId.split(',')[0]).children.find(project => project.id == this.projectId.split(',')[1]
        );
      this.contacts = this.projects.find(parentProject => parentProject.id == this.projectId.split(',')[0]).contacts;
      // obtenemos la traducción de las skills de los jobtype por cliente
      this.translateService.use('projects__' + this.projectId.split(',')[1] + '__es-ES');
    } else {
      this.projectSelected = undefined
      // volvemos a poner el idioma español por si se ha obtenido las traducciónes de algun liente
      this.translateService.use(this.currentConsultant?.client.defaultLanguage ?? 'es-ES');
    }
  }

  async copyHomeLink(url) {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(url);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // Descarga el fichero con los datos
  async downloadCsvFile(invitation, candidates, nameFile, headers) {
    const arrayInvitation = invitation;
    try {
      const candidateData: any = [];
      if (candidates && arrayInvitation) {
        for (let index = 0; index < candidates.length; index++) {
          const candi = candidates[index];
          const invi = arrayInvitation[index];
          let token = '';
          token = this.utilsService.getHomeLink(invi.token);
          candidateData.push({
            FirstName: candi.name,
            Surname1: (!candi.surname1) ? '' : candi.surname1,
            Surname2: (!candi.surname2) ? '' : candi.surname2,
            MailAddress: (!candi.email) ? '' : candi.email,
            DocumentNumber: (!candi.idCard) ? '' : candi.idCard,
            Link: token,
            Id: invi.id
          });
        }
      }
      await this.utilsService.exportToCsv(candidateData, nameFile, headers);
    } catch (error) {
      console.error(error);
    }
  }

  // Funcion recursiva.
  setInviteAsSequence(elements: any[], officeId: number, index: number, assignAndCopy: boolean, candidates: Candidate[], clientId: number) {
    // Dividimos el objeto y mandamos en partes realizando llamadas paralelas
    const data = {
      candidateId: elements[index].map(candidate => ({ id: candidate.id, randstadCandidate: candidate.randstadCandidate })),
      clientId: clientId,
      officeId: officeId,
      jobtypeId: this.skillTests.length ? this.jobtype.id : null,
      languageId: this.language,
      invitationGroupId: this.process.id,
      tests: this.getTests(),
      reopenedFrom: null,
      projectId: this.projectSelected ? this.projectSelected.id : null,
      onlyCreate: assignAndCopy
    };

    const requestStartDate = Date.now();

    this.invitationService.sendV2(data).pipe(
      finalize(() => {
        if (index < elements.length - 1) {
          this.setInviteAsSequence(elements, officeId, (index + 1), assignAndCopy, candidates, clientId);
        }
      })
    )
      .subscribe(invitation => {
        if (invitation) {
          this.multipleInvitationResult.push((invitation as any).filter(inv => inv.token !== 'error' && inv.token !== 'reminder'));
          this.responseTimes.push(Math.round((Date.now() - requestStartDate) / 1000));
        }

        for (const inv of (invitation as any).filter(inv => inv.token === 'error' || inv.token === 'reminder')) {
          this.errorEmails.push(candidates.find(can => can.id === inv.candidateId).email);
          if (inv.token === 'reminder') {
            this.reminderEmails.push(candidates.find(can => can.id === inv.candidateId).email);
          }
        }
      }, error => {
        if (error.message === 'No se puede invitar a la prueba. Dispone de una prueba sin finalizar.') {
          // Cuando uno de los lotes contiene una sola prueba entra en conflicto con la logica para invitación normal
          // Pero como solo es uno, si ocurre simplemente tomamos el candidato que se envió y lo agregamos a los errores
          this.errorEmails.push(candidates.find(candidate => candidate.id === elements[index][0].id).email);
          this.reminderEmails.push(candidates.find(candidate => candidate.id === elements[index][0].id).email);
        } else {
          this.errorEmails.push(...JSON.parse(error.message).error);
        }
        // cerramos modal
        if (this.showAsModal) {
          this.modalRef.close('Invitation Sent');
        }
      }) // suscribe end
      .add(() => {
        this.multipleInvitationResult.forEach(item => {
          // tslint:disable-next-line: no-shadowed-variable
          item.forEach((element: { id: any; token: any; }) => {
            if (this.invitationResult.findIndex(x => x.id === element.id) === -1) {
              this.invitationResult.push({
                id: element.id,
                token: element.token
              });
            }
          });
        });
        // entra cuando haya pasado por todos los candis (sean correctos o no)
        if (candidates.length === (this.invitationResult.length + this.errorEmails.length)) {
          // Si no hay ninguna correcta no se continua
          if (this.invitationResult.length !== 0) {
            this.multipleCandidatesDownloadCsvFile(assignAndCopy, this.invitationResult, candidates);
          }

          setTimeout(() => {
            this.step = 'testsUploadResume';
          }, 1000);
        }

      }); // add suscribe end
  }

  // Para la gestión del fichero si se decide asignar y copiar enlace
  multipleCandidatesDownloadCsvFile(assignAndCopy, invitation, candidates) {
    if (invitation) {
      if (assignAndCopy) {
        // multiples candidatos
        const headers = ['FirstName', 'Surname1', 'Surname2', 'MailAddress', 'DocumentNumber', 'Link', 'Id'];
        const nameFile = 'candidates-template';
        this.downloadCsvFile(invitation, candidates, nameFile, headers);
        this.utilsService.toast('success', 'INVITESCOPY');
      } else {
        this.utilsService.toast('success', 'InviteSent');
      }
    }
    this.notifyAdnReport = false;
    this.notifyMindsetDigitalReport = false;
    if (this.showAsModal) {
      this.modalRef.close('Invitation Sent');
      this.inviteSent.emit();
    }
  }

  exportErrors(emails: string[]) {
    const headers = ['name', 'surname1', 'surname2', 'email', 'idCard'];
    this.selectedCandidates$.pipe(take(1)).subscribe(candidates =>
      this.utilsService.exportToCsv(candidates.filter(candidate => emails.includes(candidate.email)), 'candidates-errors', headers)
    );
  }

  uploadProgress(): number {
    return (this.invitationResult.length + this.errorEmails.length) * 100 / this.totalCandidates;
  }

  estimatedTime(): string {
    if (!this.responseTimes.length) {
      return this.utilsService.secondsToTime((this.totalCandidates - this.invitationResult.length) * 5);
    } else {
      // El tiempo estimado sera igual al promedio de los tiempos de respuesta multiplicado por el numero de llamadas restante
      return this.utilsService.secondsToTime(
        (this.totalCandidates - this.invitationResult.length) *
        (
          this.responseTimes.reduce((total, current) => total + current, 0) /
          (this.responseTimes.length * (AppConfig.settings.SIZE_ARRAY_IN_GROUP || 3))
        )
      );
    }
  }

  // Mostramos warning
  // Controlaremos que cuando el consultor seleccione un test de evalualia que no sean (1,2,24 o 25) solo podra invitar en espanol.
  showEvalualiaWarning() {
    const testModelIds = this.getTestModelsIds();
    let checkEvalualiaTest = false;
    for (const val of testModelIds) {
      if (!this.TestFromCtArr.includes(val)) {
        checkEvalualiaTest = true;
        break;
      } else {
        checkEvalualiaTest = false;
      }
    }

    if (checkEvalualiaTest) {
      this.utilsService.toast('warning', 'knowledgetest');
      this.language = 1;
    }
    this.showLanguageRequired();
    this.evalualiaTest = checkEvalualiaTest;
  }

  // Deshabilitamos el selector en función a los test elegidos de conocimientos
  disabledLanguageSelector() {
    if (this.evalualiaTest && this.knowledgeTests.length !== 0) {
      const ctTests = this.knowledgeTests.filter(id => this.TestFromCtArr.includes(id.id));
      // Comprobamos si hay test propios de CT
      if (ctTests.length !== 0 && this.knowledgeTests.length === 1) {
        return false;
      } else if (ctTests.length !== 0 && this.knowledgeTests.length > 1) {
        return true;
      } else if (ctTests.length === this.knowledgeTests.length) {
        return false;
      } else {
        return true;
      }

    } else {
      return false;
    }

  }

  // Deshabilitar botón para enviar invitación
  disableSendButton() {
    if (!this.skillTests.length && !this.knowledgeTests.length) {
      return true;
    } else if (this.language === null) {
      return true;
    } else {
      return false;
    }
  }

  // Mostramos el div del campo requerido
  showLanguageRequired() {
    if (this.language === null) {
      this.languageRequired = true;
    } else {
      this.languageRequired = false;
    }
  }

  // Función para las opciones en la prueba de razonamiento.
  optionsKnowledgeTestLevels(event) {
    this.knowledgeTestLevels.forEach(level => { level.value == event.target.value ? level.checked = event.target.checked : null });

    let removeTestId = 0;
    // Filtramos las pruebas de conocimientos exclusivamente por las de Candidate Testing
    this.knowledgeTests.filter(test => test.origin === 'ct').forEach(test => {
      // marcamos para eliminar los test que no tienen niveles.
      if (this.knowledgeTestLevels.filter(level => level.testModelId === test.id && level.checked).length === 0) {
        removeTestId = test.id;
      }
    });

    // Eliminamos del array test si corresponde y solo si es del modelo del seleccionado
    // (hecho para evitar que se elimine test sin niveles cuando son test que nunca tuvieron niveles)
    if (removeTestId && event.target.name.includes(removeTestId)) {
      this.knowledgeTests.splice(this.knowledgeTests.findIndex(test => test.id === removeTestId), 1);
    }
  }

  getTests() {
    const testsModelIds = this.getTestModelsIds();
    const result = [];
    const autonotifyCtReportsArray = this.autonotifyCtReports.map(testModel => testModel.id)

    // Para el resto de test
    testsModelIds.forEach(testModelId => {
      result.push({
        testModelId: testModelId,
        levels: this.knowledgeTestLevels.filter(level => level.testModelId === testModelId && level.checked).map(level => level.value),
        autonotifyReport: this.utilsService.ADNTestModelIds.includes(testModelId) ? this.notifyAdnReport : autonotifyCtReportsArray.includes(testModelId),
        autonotifyMindsetDigitalReport: this.utilsService.ADNTestModelIds.includes(testModelId) ? this.notifyMindsetDigitalReport : false
      });
    });

    this.autonotifyCtReports.map(testModel => testModel.id)
    return result;
  }

  filterKnowledgeTestLevels(testModel: TestModel): any {
    return this.knowledgeTestLevels.filter(level => level.testModelId === testModel.id);
  }

  ngOnDestroy(): void {
    // volvemos a poner el idioma español por si se ha obtenido las traducciónes de algun liente
    this.translateService.use(this.currentConsultant?.client.defaultLanguage ?? 'es-ES');
  }
}
